// extracted by mini-css-extract-plugin
export var container = "_g6-0";
export var content = "_g6-3";
export var customerTitle = "_g6-4";
export var empty = "_g6-5";
export var gray = "_g6-6";
export var header = "_g6-7";
export var info = "_g6-8";
export var loading = "_g6-2";
export var loadingCard = "_g6-9";
export var oneLine = "_g6-a";
export var personName = "_g6-e";
export var pillContainer = "_g6-b";
export var selected = "_g6-1";
export var text = "_g6-c";
export var twoLines = "_g6-d";
export var unread = "_g6-f";
export var unreadIndicator = "_g6-g";